export default __webpack_public_path__ + "static/media/what.aa35d6fa.jpg";